module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ec-Ga.7e942d88.png";